module.exports = __webpack_public_path__ + "5b8ff955932279de863cf38c7f26f56b.svg";